import React from 'react';
import './Icon.scss';
import AttachmentIcon from '../../../components/svg/AttachmentIcon';
import CircleIcon from './CircleIcon';

const FileIcon = () => {
  return (
    <CircleIcon className="file">
      <AttachmentIcon className="attachment-icon" />
    </CircleIcon>
  );
};

export default FileIcon;
